export default {"src":"/_next/static/media/paypal.0005c255.svg","height":450,"width":374,"blurWidth":0,"blurHeight":0};